import React from 'react';
import { useNavigate, Link } from "react-router-dom";
import { useFormInputValidation } from "react-form-input-validation";
import { useState } from 'react';

import './home.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Pagination from 'react-bootstrap/Pagination';

import { IoEyeOutline } from "react-icons/io5";
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';

import { FaGoogle } from "react-icons/fa";

import Card from 'react-bootstrap/Card';

import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import {connect} from 'react-redux';
import * as actions from '../../store/customer/actions';

let active = 2;
let items = [];
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>,
  );
}

const ForgetPassswordPage = ({signUp}) => {  
    const navigate = useNavigate(); 
    const [formData, setFormData] = useState({
        email: ""
    });

	const [ errors, setErrors ] = useState({});
    
	
	const [processing, setProcessing] = useState(false);
	const [ responseError, setResponseError ] = useState();
    const [successMessage, setSuccessMessage] = useState(null);

    const handleChange = (e) => { 
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });  
        findFormErrors();
    }


    const validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
    }

    const findFormErrors = () => {
        const { full_name, email, mobile, password, confirm_password, member_type } = formData
        let newErrors = {}

        
        // password errors
        if ( !full_name || full_name === '' ) newErrors.full_name = 'Name cannot be blank!'
        if ( !email || email === '' ) newErrors.email = 'Enter email address'
        if ( !mobile || mobile === '' ) newErrors.mobile = 'Enter mobile address'
        if ( !member_type || member_type === '' ) newErrors.member_type = 'Select your type'
        if ( !password || password === '' ) newErrors.mobile = 'Enter password'
        if ( !confirm_password || confirm_password === '' ) newErrors.confirm_password = 'Enter confirm password'
        if(confirm_password){
            if(password != confirm_password){
                newErrors.confirm_password = 'Password mismatch'
            }
        }
        
        if(email && !validateEmail(email)){
            newErrors.email = 'Your e-mail has been entered in the wrong format. Please check and try again';
          }
        // console.log('newErrors', newErrors)
        setErrors(newErrors);
        return newErrors
    }
	
	const handleSubmit = (event) => { 
        const checkErrors = findFormErrors();
		
		const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        // console.log('check 2', Object.keys(checkErrors).length)
        if ( Object.keys(checkErrors).length > 0 ) {
            // We got errors!
            setErrors(checkErrors);
            // console.log('check 3');
        } else {
            // Create REgistration
            setSuccessMessage('Please check your email to reset your password');
			const myTimeout = setTimeout(redirectSignIn, 2000);
        }
	}

    const  redirectSignIn = () => {
		navigate('/signin');
	}

    return (
        <div>
            <Header/>
            <section className='pt-5 pb-5 bg-dark'>
                <h3 className='text-center'>Recover Password</h3>
            </section>
            <section className='pt-5 pb-5'>
                <Container>
                    <Row className='justify-content-center'>
                        <Col xs={6}>
                            <Card className='shadow p-4'>
                                <Card.Body>
                                    <h2 className='text-center'>Forget Password</h2>
                                    
                                    <form className='mt-4' noValidate onSubmit={handleSubmit}>
                                        <Form.Group className={ errors.email ? "input-error mb-3" : "mb-3"} controlId="formGroupEmail">
                                            <Form.Control type="email" placeholder="Email address" name="email" onChange={handleChange} />
                                            <Form.Control.Feedback type="invalid">
                                                { errors.email }
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Button type="submit" className='d-block w-100 btn-lg mt-3'>Recover Password</Button>
                                        <div className='text-center mt-4'>Don’t have account? <Link to={'/signup'}>Sign Up</Link></div>
                                    </form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Footer/>
        </div>
    )
}

function mapStateToProps(state) {
    return {
      
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
          signUp: (post) => dispatch(actions.forgetPassword(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(ForgetPassswordPage);